export default function css(...args){
    return Object.assign({}, ...args);
}